import { routeLabels } from './routeManifest'

function humanize(segment) {
  if (routeLabels[segment]) return routeLabels[segment]
  if (/^[0-9a-f-]{8,}$/i.test(segment)) return 'Detail'
  return segment.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
}

/**
 * @param {string} pathname
 * @returns {{ key: string, label: string, to?: string }[]}
 */
export function resolveBreadcrumbs(pathname) {
  if (pathname === '/' || pathname === '') {
    return [{ key: 'root', label: 'Home', to: '/dashboard' }]
  }
  const parts = pathname.split('/').filter(Boolean)
  const crumbs = [{ key: 'home', label: 'Home', to: '/dashboard' }]
  let acc = ''
  parts.forEach((seg, idx) => {
    acc += `/${seg}`
    const isLast = idx === parts.length - 1
    const isId = /^[0-9a-f-]{8,}$/i.test(seg) || /^\d+$/.test(seg)
    crumbs.push({
      key: acc,
      label: humanize(seg),
      to: isLast || isId ? undefined : acc,
    })
  })
  return crumbs
}
